import { useEffect, DependencyList } from 'react';
import { useRouter } from 'next/router';

const useSlug = (slug = '', dependency: DependencyList = []): null => {
  const router = useRouter();

  useEffect(() => {
    router.replace('/' + slug, undefined, { shallow: true });
  }, dependency);

  return null;
};

export default useSlug;
